/**
 * Generated by orval. Do not edit manually.
 */

export type InsiderAppUsageChoice =
  (typeof InsiderAppUsageChoice)[keyof typeof InsiderAppUsageChoice]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const InsiderAppUsageChoice = {
  solutions: 'solutions',
  trainer_drills: 'trainer_drills',
  board_reports: 'board_reports',
  analyzer: 'analyzer',
  pokerarena: 'pokerarena',
  new_here: 'new_here',
} as const
